/** Vehicle / plate helpers for collected invoice item البيان */

export const pickVehicleFieldsFromSource = (source = {}) => {
  const plateFallback = String(source?.vehicle_license_plate || "").trim();
  const vehicleId =
    source?.vehicle_id != null && String(source.vehicle_id).trim() !== ""
      ? String(source.vehicle_id)
      : "";

  return {
    vehicle_id: vehicleId,
    vehicle_license_plate_ar: String(
      source?.vehicle_license_plate_ar || plateFallback || ""
    ).trim(),
    vehicle_license_plate_en: String(
      source?.vehicle_license_plate_en || plateFallback || ""
    ).trim(),
  };
};

export const getVehicleDetailsPath = (vehicleId) => {
  if (vehicleId == null || String(vehicleId).trim() === "") return null;
  return `/vehicles_plural/view/${vehicleId}`;
};

export const getItemPlateText = (item, showPlateStatement) => {
  if (showPlateStatement === "show_ar") {
    return String(item?.vehicle_license_plate_ar || "").trim();
  }
  if (showPlateStatement === "show_en") {
    return String(item?.vehicle_license_plate_en || "").trim();
  }
  return "";
};

const stripLeadingPlate = (description, plate) => {
  const desc = String(description || "");
  const plateText = String(plate || "").trim();
  if (!plateText) return desc;
  const trimmed = desc.trim();
  if (!trimmed.startsWith(plateText)) return desc;
  return trimmed
    .slice(plateText.length)
    .replace(/^[\s\-–—:|/]+/, "")
    .trim();
};

/** Free-text portion of البيان (plate shown separately in the UI). */
export const getItemDescriptionWithoutPlate = (item, showPlateStatement) => {
  const plate = getItemPlateText(item, showPlateStatement);
  return stripLeadingPlate(item?.description, plate);
};

/** Full description sent to the API when إظهار بيان اللوحة is active. */
export const composeItemDescriptionWithPlate = (item, showPlateStatement) => {
  const plate = getItemPlateText(item, showPlateStatement);
  const rest = getItemDescriptionWithoutPlate(item, showPlateStatement);
  if (!plate) return rest;
  if (!rest) return plate;
  return `${plate} ${rest}`;
};

export const mapItemsDescriptionsWithPlate = (items, showPlateStatement) => {
  if (!Array.isArray(items)) return [];
  return items.map((item) => ({
    ...item,
    description: composeItemDescriptionWithPlate(item, showPlateStatement),
  }));
};
